<template>
	<div class="campaigns-container">
		<div class="coming-soon-banner">
			<div class="banner-content">
				<h1 class="banner-title">{{ getString('campaigns_coming_soon_title') }}</h1>
				<p class="banner-description">{{ getString('campaigns_coming_soon_description') }}</p>
				<div class="banner-action">
					<AppButton
						v-if="!isInterested"
						:text="getString('campaigns_im_interested')"
						:loading="isLoading"
						:disabled="isLoading"
						@click="handleInterestClick"
						inverted
						class="main-cta"
					/>
					<div v-else class="already-registered">
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<span>{{ getString('campaigns_already_registered') }}</span>
					</div>
				</div>
			</div>
			<div class="banner-visual">
				<div class="visual-placeholder" v-html="getIcon('iconCampaigns')"></div>
			</div>
		</div>
	</div>
</template>

<script>
import {useLanguageStore, useNotificationStore, useSvgStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores/user.store";
import AppButton from "@/shared/components/AppButton.vue";
import API from "@/shared/helpers/API";

export default {
	name: "CampaignsContainer",
	components: {AppButton},
	setup() {
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		const userStore = useUserStore();
		const svgStore = useSvgStore();
		return {
			languageStore,
			notificationStore,
			userStore,
			getIcon: svgStore.get,
			getString: languageStore.getString,
			showNotification: notificationStore.showNotification
		};
	},
	data() {
		return {
			isInterested: false,
			isLoading: false
		};
	},
	mounted() {
		// Check localStorage if user already registered interest
		const key = `campaigns_interest_${this.userStore.currBusinessId}`;
		this.isInterested = localStorage.getItem(key) === 'true';
	},
	methods: {
		handleInterestClick() {
			if (this.isInterested) return;

			this.isLoading = true;
			API.init().recordComingSoonInterest(
				this.userStore.currBusinessId,
				'campaigns',
				(resp) => {
					this.isLoading = false;
					if (resp && resp.result && resp.result === "OK") {
						this.isInterested = true;
						// Store in localStorage to persist state
						const key = `campaigns_interest_${this.userStore.currBusinessId}`;
						localStorage.setItem(key, 'true');
						this.showNotification('campaigns-interest-registered');
					} else {
						this.showNotification('generic-fail');
					}
				}
			);
		}
	}
};
</script>

<style scoped lang="scss">
.campaigns-container {
	max-width: 1200px;
	margin: 0 auto;
}

.coming-soon-banner {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border-radius: 16px;
	padding: 48px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 48px;
	color: white;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

	@media (max-width: 768px) {
		flex-direction: column;
		padding: 32px 24px;
		gap: 32px;
	}
}

.banner-content {
	flex: 1;
	max-width: 600px;
}

.banner-title {
	font-size: 32px;
	font-weight: 700;
	margin: 0 0 16px 0;
	line-height: 1.2;

	@media (max-width: 768px) {
		font-size: 24px;
	}
}

.banner-description {
	font-size: 16px;
	line-height: 1.6;
	margin: 0 0 32px 0;
	opacity: 0.95;
}

.banner-action {
	display: flex;
	align-items: center;

	.main-cta {
		height: 48px;
	}
}

.already-registered {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 24px;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 8px;
	font-weight: 600;
	backdrop-filter: blur(10px);

	svg {
		color: white;
	}
}

.banner-visual {
	flex-shrink: 0;

	@media (max-width: 768px) {
		display: none;
	}
}

.visual-placeholder {
	width: 200px;
	height: 200px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 16px;
	backdrop-filter: blur(10px);

	&:deep(svg) {
		width: 120px;
		height: 120px;
		fill: white;
	}
}
</style>
